import Vue from 'vue'
import Router from 'vue-router'

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

Vue.use(Router)

/* Layout */
// import Layout from '@/components/common/Home.vue'
import Layout from '@/layout'

// 静态路由
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index'),
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login/Login.vue'),
    hidden: true,
    meta: { title: 'Welcome to login' },
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    meta: { title: '' },
    hidden: true,
    children: [
      {
        path: '/404',
        name: '404',
        component: () => import('@/views/404.vue'),
        hidden: true,
        meta: { title: '404' },
      },
      {
        path: '/403',
        name: '403',
        component: () => import('@/views/403.vue'),
        hidden: true,
        meta: { title: '403' },
      },
      {
        path: '/500',
        name: '500',
        component: () => import('@/views/500.vue'),
        hidden: true,
        meta: { title: '500' },
      },
      {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/Home.vue'),
        hidden: true,
        meta: { title: 'Home' },
      },
      {
        path: '/upload',
        name: 'Upload',
        component: () => import('@/views/Upload/picture/index.vue'),
        hidden: true,
        meta: { title: 'Upload' },
      },
      {
        path: '/test',
        name: 'Test',
        component: () => import('@/views/Test.vue'),
        hidden: true,
        meta: { title: 'Test' },
      },
      {
        path: '/userDetail/:userId',
        name: 'UserDetail',
        parentName: 'UserManageList',
        hidden: true,
        component: () => import('@/views/User/UserDetail.vue'),
        meta: { title: 'User Detail', permission: 'app:user:manage:detailInfo', type: 1 }, 
      },
      {
        path: '/merchantProductDetail/:id',
        name: 'MerchantProductDetail',
        parentName: 'MerchantProductList',
        hidden: true,
        component: () => import('@/views/LoanMarket/MerchantProductDetail.vue'),
        meta: { title: 'Merchant Product Detail', permission: 'loanMarket:merchantProductList:detailInfo', type: 1 }, 
      },
      {
        path: '/cases/:id',
        name: 'TeleCaseDetail',
        parentName: 'TeleCases',
        component: () => import('@/views/Telemarket/CaseDetail.vue'),
        meta: { title: 'Tele case detail', permission: 'tele:cases:detail', type: 1 },
      }
    ],
  },
]

// 动态路由
export const asyncRoutes = [
  {
    path: '/userManage',
    component: Layout,
    alwaysShow: true, // will always show the root menu
    name: 'UserManage',
    parentName: '',
    meta: {
      title: 'User Manage',
      icon: 'el-icon-user',
      type: 0,
      permission: ['app:user:manage', 'app:user:userWhiteList']
    },
    children: [
      {
        path: '/userManageList',
        name: 'UserManageList',
        parentName: 'userManage',
        component: () => import('@/views/User/UserManageList.vue'),
        meta: { title: 'User Manage', permission: 'app:user:manage', type: 1 },
      },
      {
        path: '/userWhiteList',
        name: 'UserWhiteList',
        parentName: 'userManage',
        component: () => import('@/views/User/UserWhiteList.vue'),
        meta: { title: 'User Manage', permission: 'app:user:userWhiteList', type: 1 },
        children: [{
          hidden: true,
          isOperation: true,
          path: '',
          name: 'action:delete',
          parentName: 'UserWhiteList',
          meta: { title: 'Action Delete', permission: 'app:user:manage:delete', type: 2 },
        }]
      },
      {
        path: '/closeUserRecord',
        name: 'CloseUserRecord',
        parentName: 'userManage',
        component: () => import('@/views/User/CloseUserRecord.vue'),
        meta: { title: 'Close User Record', permission: 'app:user:manage', type: 1 },
      },
    ],
  },
  {
    path: '/financial',
    component: Layout,
    alwaysShow: true, // will always show the root menu
    name: 'Financial',
    parentName: '',
    meta: {
      title: 'Transaction Manage',
      icon: 'el-icon-money',
      type: 0,
      permission: ['transaction:manage', 'merchant:withdraw:confirm']
    },
    children: [
      {
        path: '/transactionManageList',
        name: 'TransactionManageList',
        parentName: 'Financial',
        component: () => import('@/views/Order/TransactionManageList.vue'),
        meta: { title: 'Transaction Manage', permission: 'transaction:manage', type: 1 },
      },
      {
        path: '/merchantWithdrawConfirm',
        name: 'MerchantWithdrawConfirm',
        parentName: 'Financial',
        component: () => import('@/views/Order/MerchantWithdrawConfirm.vue'),
        meta: {
          title: 'Merchant Withdraw Confirm',
          permission: 'merchant:withdraw:confirm',
          type: 1
        },
      },
    ],
  },
  {
    path: '/collectionManage',
    component: Layout,
    alwaysShow: true, // will always show the root menu
    name: 'CollectionManage',
    parentName: '',
    meta: {
      title: '催收管理',
      icon: 'el-icon-service',
      type: 0,
      permission: ['collection:manage:repaymentPlanList', 'collection:manage:flatAccountRecords']
    },
    children: [
      {
        path: 'repaymentPlanList',
        name: 'RepaymentPlanList',
        parentName: 'CollectionManage',
        component: () => import('@/views/Order/RepaymentPlanList.vue'),
        meta: {
          title: '待还款账单',
          permission: 'collection:manage:repaymentPlanList', 
          type: 1
        },
      },
      {
        path: 'flatAccountRecords',
        name: 'FlatAccountRecords',
        parentName: 'CollectionManage',
        component: () => import('@/views/Order/FlatAccountRecords.vue'),
        meta: {
          title: '平账记录',
          permission: 'collection:manage:flatAccountRecords', 
          type: 1
        },
      },
    ],
  },
  {
    path: '/marketing',
    component: Layout,
    alwaysShow: true, // will always show the root menu
    name: 'Marketing',
    parentName: '',
    meta: {
      title: 'marketing',
      icon: 'el-icon-shopping-bag-2',
      type: 0,
      permission: ['app:commentsList:manage'],
    },
    children: [
      {
        path: '/commentsList',
        name: 'CommentsList',
        parentName: 'Marketing',
        component: () => import('@/views/Comment/CommentsList.vue'),
        meta: {
          title: 'APP CommentsList',
          permission: 'app:commentsList:manage', 
          type: 1
        },
      },
    ],
  },
  {
    path: '/configuration',
    component: Layout,
    alwaysShow: true, // will always show the root menu
    name: 'Configuration',
    parentName: '',
    meta: {
      title: 'Operation Manage',
      icon: 'el-icon-suitcase-1',
      type: 0,
      permission: ['faq:manage']
    },
    children: [
      {
        path: '/faqManageList',
        name: 'FaqManageList',
        parentName: 'Configuration',
        component: () => import('@/views/Operation/FaqManageList.vue'),
        meta: { title: 'FAQ Manage', permission: 'faq:manage', type: 1 },
      },
    ],
  },
  {
    path: '/system',
    component: Layout,
    alwaysShow: true, // will always show the root menu
    name: 'System',
    parentName: '',
    meta: {
      title: 'System Manage',
      icon: 'el-icon-setting',
      type: 0,
      permission: ['system:user', 'system:role', 'system:permission', 'system:department'],
    },
    children: [
      {
        path: 'systemDepartment',
        name: 'SystemDepartment',
        parentName: 'System',
        component: () => import('@/views/System/SystemDepartment.vue'),
        meta: { title: 'System Department', permission: 'system:department', type: 1 },
      },
      {
        path: 'systemUser',
        component: () => import('@/views/System/SystemUser.vue'),
        name: 'SystemUser',
        parentName: 'System',
        meta: { title: 'System User', permission: 'system:user', type: 1 },
      },
      {
        path: 'systemRole',
        name: 'SystemRole',
        parentName: 'System',
        component: () => import('@/views/System/SystemRole.vue'),
        meta: { title: 'System Role', permission: 'system:role', type: 1 },
      },
      {
        path: 'systemPermission',
        name: 'SystemPermission',
        parentName: 'System',
        component: () => import('@/views/System/SystemPermission.vue'),
        meta: { title: 'System Permission', permission: 'system:permission', type: 1 },
      },
      {
        path: 'systemMenu',
        name: 'SystemMenu',
        component: () => import('@/views/System/SystemMenu.vue'),
        meta: { title: 'System Menu', permission: 'system:menu', type: 1 },
      }
    ],
  },
  {
    path: '*',
    redirect: '/403',
  },
]

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
